import React from 'react';
import ContactComp from "../components/ContactPage/ContactComp";

const Contact = () => {
    return (
        <ContactComp/>
    );
};

export default Contact;